import {
  BatterReportChartConfigDto,
  ChartType,
  PercentileRankingView,
  PercentileRankingsChartConfigDto,
  PitcherReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import GenericDraggableCheckboxConfig from 'components/Configs/GenericDraggableCheckboxConfig';

type ReportConfig = PitcherReportChartConfigDto | BatterReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<PercentileRankingsChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  configKey: keyof TReportConfig;
};

const PercentileRankingsChartSidebar = <T extends ReportConfig>({
  chartConfig,
  setTempLayout,
  tempLayout,
  chartId,
  configKey,
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId, chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['Percentiles', 'Values'] satisfies PercentileRankingView[]}
        selected={chartConfig.viewDataAs}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [configKey]: { ...tempLayout[configKey], viewDataAs: selected },
          })
        }
        disabled={false}
      />
      <GenericDraggableCheckboxConfig
        label={t('Visible stats')}
        draggableCheckboxes={chartConfig.visibleStats}
        setDraggableCheckboxes={(draggableCheckboxes) => {
          setTempLayout({
            ...tempLayout,
            [configKey]: {
              ...tempLayout[configKey],
              visibleStats: draggableCheckboxes,
            },
          });
        }}
        useShortLabels={true}
      />
    </div>
  );
};

export default PercentileRankingsChartSidebar;
